import React from "react";
import clsx from "clsx";
import Typography from "@material-ui/core/Typography";
import useDescriptions from "@micado-digital/react-shop/ProductDetail/hooks/useDescriptions";

import styles from "./PreAnnouncement.styles";

const PreAnnouncement = ({ lang }) => {
	const descriptions = useDescriptions({ lang, type: "pre-announcement" });
	const { description } = descriptions || {};
	const css = styles();

	if (!description) return <></>;

	return (
		<Typography
			className={clsx(css.preAnnouncement, "mco-shop-product-detail-pre-announcement")}
			component="div"
			dangerouslySetInnerHTML={{ __html: description }}
		/>
	);
};

export default PreAnnouncement;
